import React from 'react';
import { Header, Segment, Tab, Loader } from 'semantic-ui-react';
import axios from 'axios/index';
import Responsive from 'semantic-ui-react/dist/commonjs/addons/Responsive/index';
import ReportTypeTemplate from './ReportTypeTemplate';

export default class AllReports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            section: {
                id: null
            },
            reportTypes: []
        };

        this.getReportTypesForSection = this.getReportTypesForSection.bind(this);
    }

    componentDidMount() {
        this.getReportTypesForSection();
    }

    getReportTypesForSection() {
        let sectionKey = this.props.reportSectionKey;

        axios.get(`/report/section/${sectionKey}/`)
            .then(res => {
                this.setState({
                    section: res.data
                });
            })
            .then((res) => {
                axios.get(`/report/types/${this.state.section.id}/`)
                    .then((ress) => {
                        let reportTypes = ress.data;

                        this.setState({}, () => {
                            const panes = reportTypes.map((e) => ({
                                menuItem: e.displayName,
                                render: () => (
                                    <Tab.Pane attached={false} as={Responsive} >
                                        <ReportTypeTemplate reportTypeId={e.id} />
                                    </Tab.Pane>)
                            }));
                            this.setState({ panes, loading: false });
                        });
                    })
                    .catch((err) => {
                        console.log('Failed to fetch report types!');
                    });
            }).catch(err => {
                console.log('Failed to fetch report section!');
            });
    }

    render() {
        const { panes } = this.state;

        return (
            <div>

                <Header as="h1"> Izvještaji </Header>

                <Segment.Group raised>
                    <Segment>
                        <Header as="h3"> Spisak izvještaja </Header>
                    </Segment>
                    <Segment clearing>

                        {this.state.loading ?
                            <div style={{ paddingTop: '100px', paddingBottom: '100px' }}>
                                <Loader active inline="centered" />
                            </div> :
                            <Tab
                                panes={panes}
                                menu={{ secondary: true, pointing: true, color: 'blue' }}
                            />}

                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Reports/AllReports.js